import React from 'react';
import classes from './PageLoading.module.scss';

const PageLoading = () => {
    /*return (
        <div className={classes.loading}>
            <span>S</span>
            <span>T</span>
            <span>A</span>
            <span>N</span>
            <span>D</span>
            <span>A</span>
            <span>R</span>
            <span>D</span>
        </div>
    );*/
    return (
        <div className={classes.loading}>
            <div className={classes.line}>
                {'Le Khai Lab'.split('').map((char, index) => (
                    <span key={index}>{char}</span>
                ))}
            </div>
            <div className={classes.line}>
                {'Est. 2018'.split('').map((char, index) => (
                    <span key={index}>{char}</span>
                ))}
            </div>
        </div>
    );
};

export default PageLoading;
